import React, { useEffect, useState } from "react";
import { Link, Prompt, useHistory, useLocation, } from "react-router-dom";
import Select, { components } from "react-select";
import { IMAGE_URL, TABLE_ROWS_PER_PAGE, } from "../../../../utils/Constants";
import PermissionsGate from "../../../../utils/permissionGate";
import { InitialRender } from "../../../common/Helper";
import Hover from "../../../common/Hover";
import { TrimText } from "../../../common/TrimText";
import { ColorRender } from "../../../systemadministration/usermanagement/CheckRole";
import {
    ModalOverlay,
    ModalContainer,
    ModalHeader,
    ModalTitle,
    CloseButton,
    ModalDescription,
    FieldGroup,
    FieldLabel,
    TogglesRow,
    ToggleContainer,
    ErrorMessage,
    ModalFooter,
    CancelButton,
    multiSelectStyles,
} from "./PMCGradeBook.styles";
import Button from "../../../library/Button";
import ToggleButton from "../../../library/ToggleButton";

import axios from "axios";
import ExcelJS from 'exceljs';
import JsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Papa from "papaparse";
import { useRef } from "react";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { usePermissionGuardRedirect } from "../../../../hooks/usePermissionGuard";
import SkeletonTicketList from "../../../../loaders/SkeletonTicketList";
import { getPMCFiltersCancelToken, updateCousesScore, updatePmcScoreCancelToken } from "../../../../services/GradeSettingService";
import { getProgramGradebookModuleList, getProgrammeModulesGradeStudentList, exportGradebookExcel, getGradebookOriginIntakes, getGradebookProgrammeCode } from "../../../../services/ProgrammeServices";
import { RenderQuizAttemptResultStatus } from "../../../../utils/CommonStatusItems";
import Str from "../../../common/Str";
import Tablefilter from "../../../common/Tablefilter";
import { twoDecimalRound } from "../../../../utils/commonFunction";

const stdIds = [];

const MultiValueRemove = (props) => (
    <components.MultiValueRemove {...props}>
        <i className="fal fa-times"></i>
    </components.MultiValueRemove>
);

function PMCGradeBook(props) {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const queryVersionId = query.get("versionId");
    const queryProgrammeId = query.get("programmeId")
    const history = useHistory();
    const firstLoaded = useRef(true);
    const [debouncedTerm, setDebouncedTerm] = useState("");
    const [search, setSearch] = useState("");
    const debounceTimeoutRef = useRef(null);
    const [userData, setUserData] = useState([]);
    const [loading, setLoading] = useState({ list: false, heading: false });
    const [moduleHeader, setmoduleHeader] = useState([]);
    const [updateData, setUpdateData] = useState(false);
    const [percentageView, setPercentageView] = useState(false);
    const [paginationState, setPaginationState] = useState({
        from: 0,
        to: 0,
        total: 0,
        perPage: 0,
        currentPage: 0,
        lastPage: 0,
    });
    const [tableState, setTableState] = useState({ page: 1, limit: 10 });
    const [errorMessage, setErrorMessage] = useState("");
    const [tooltipValues, setTooltipValues] = useState();
    const [tableWidth, setTableWidth] = useState(0);
    const [saveGradesLoading, setSaveGradesLoading] = useState(false);
    const [updateValueArr, setUpdateValueArr] = useState([]);
    const [isCourseEdited, setIsCourseEdited] = useState(0)
    const [intake, setIntake] = useState({ arr: [], checkObj: {} });
    const [studentArr, setStudentArr] = useState([]);
    const [graduated, setGraduated] = useState({ arr: [], checkObj: {} });
    const [filterData, setFilterData] = useState({ intake: [], graduated: [] });
    const [qualifications, setQualifications] = useState([]);

    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [exportIntakeOptions, setExportIntakeOptions] = useState([]);
    const [exportIntakeLoading, setExportIntakeLoading] = useState(false);
    const [exportSelectedIntakes, setExportSelectedIntakes] = useState([]);
    const [exportIncludeNonWeighted, setExportIncludeNonWeighted] = useState(false);
    const [exportIncludeRedo, setExportIncludeRedo] = useState(true);
    const [exportGenerating, setExportGenerating] = useState(false);
    const [exportError, setExportError] = useState(null);
    const [exportProgrammeCode, setExportProgrammeCode] = useState('');
    const exportCancelledRef = useRef(false);

    const handleWidth = () => {
        const container = document.querySelector(".table-book-responsive");
        const leftTable = document.querySelector(".table-book-left");
        const midTableWrapper = document.querySelector(".table-book-mid");
        const midTable = midTableWrapper?.querySelector(".grade-acc-in");
        const rightTable = document.querySelector(".table-book-right");

        if (!container || !leftTable || !midTableWrapper || !midTable || !rightTable) return;

        // Total available width from container
        const tableWidth = container.clientWidth;
        const leftWidth = leftTable.scrollWidth;
        const rightWidth = rightTable.scrollWidth;

        // Deduct scrollbar width from midTableWrapper
        const scrollbarWidth = midTableWrapper.offsetWidth - midTableWrapper.clientWidth;
        const availableWidth = tableWidth - leftWidth - rightWidth - scrollbarWidth;

        const midCols = midTable.querySelectorAll("thead th");
        const colCount = midCols.length || 1;
        if (colCount === 0) return;

        // Calculate total width of all columns except last
        let totalOtherColsWidth = 0;
        midCols.forEach((col, index) => {
            if (index < colCount - 1) {
                totalOtherColsWidth += col.getBoundingClientRect().width;
            }
        });

        const lastCol = midCols[colCount - 1];
        if (lastCol) {
            const lastColNaturalWidth = lastCol.getBoundingClientRect().width;
            const remainingWidth = Math.max(
                lastColNaturalWidth,
                Math.floor(availableWidth - totalOtherColsWidth - 1) // small buffer to prevent overflow
            );
            lastCol.style.width = `${remainingWidth}px`;
            lastCol.style.minWidth = `${remainingWidth}px`;
        }

        const totalMidWidth = totalOtherColsWidth + (lastCol ? lastCol.offsetWidth : 0);
        midTableWrapper.style.width = `${availableWidth}px`;
        midTable.style.width = `${totalMidWidth}px`;

        const hasOverflow = midTable.scrollWidth > availableWidth + 1;
        midTableWrapper.style.overflowX = hasOverflow ? "auto" : "hidden";
        midTableWrapper.style.overflowY = "hidden";

        const leftFirst = leftTable.lastChild;
        const rightFirst = rightTable.firstChild;

        if (leftFirst && !leftFirst.classList.contains("border-shadow-custom-table")) {
            leftFirst.classList.add("border-shadow-custom-table");
        }
        if (rightFirst && !rightFirst.classList.contains("border-shadow-custom-table")) {
            rightFirst.classList.add("border-shadow-custom-table");
        }

        requestAnimationFrame(() => {
            const diff = midTable.scrollWidth - midTableWrapper.clientWidth;
            if (diff > 1 && lastCol) {
                const adjustedWidth = lastCol.offsetWidth - diff;
                lastCol.style.width = `${adjustedWidth}px`;
                lastCol.style.minWidth = `${adjustedWidth}px`;
            }
        });
    };

    // Custom debounce effect
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            setSearch(debouncedTerm);
        }, 1000);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [debouncedTerm]);

    usePermissionGuardRedirect(['cagbview']);

    useEffect(() => {
        if (userData?.length && tableWidth) {
            if (firstLoaded.current) {
                setTimeout(() => {
                    handleWidth();
                    firstLoaded.current = false;
                }, 500);
            } else {
                setTimeout(() => {
                    handleWidth();
                }, 500);
            }
        }
    }, [userData, tableWidth]);

    useEffect(() => {
        window.addEventListener("swallActive", function (e) {
            checkbtnValue(e.detail);
        });

        return () => {
            window.removeEventListener("swallActive", function (e) {
                checkbtnValue(e.detail);
            });
        };
    }, []);

    const shouldBlockNavigation = updateValueArr.length;


    const openExportModal = async () => {
        setExportModalOpen(true);
        setExportError(null);
        setExportSelectedIntakes([]);
        setExportIncludeNonWeighted(false);
        setExportIncludeRedo(true);
        setExportIntakeOptions([]);
        setExportIntakeLoading(true);
        setExportProgrammeCode('');

        try {
            const originIntakesResponse = await getGradebookOriginIntakes({ id: queryProgrammeId, versionId: queryVersionId });
            const programmeCodeResponse = await getGradebookProgrammeCode({ id: queryProgrammeId, versionId: queryVersionId });

            const availableIntakes = (originIntakesResponse?.data?.data || []).filter((intake) => Number(intake.studentCount) > 0);
            setExportIntakeOptions(availableIntakes);
            setExportProgrammeCode(programmeCodeResponse?.data?.data?.code || '');
        } catch (error) {
            setExportError('Unable to load the available origin intakes. Please try again.');
        } finally {
            setExportIntakeLoading(false);
        }
    };

    const closeExportModal = () => {
        if (exportGenerating) {
            exportCancelledRef.current = true;
            setExportGenerating(false);
        }

        setExportModalOpen(false);
    };

    const handleGenerateExport = async () => {
        if (!exportSelectedIntakes.length || exportGenerating) {
            return;
        }

        exportCancelledRef.current = false;
        setExportGenerating(true);
        setExportError(null);

        try {
            const response = await exportGradebookExcel({
                id: queryProgrammeId,
                versionId: queryVersionId,
                originIntakes: exportSelectedIntakes.map((intake) => intake.value),
                includeNonWeighted: exportIncludeNonWeighted,
                includeRedo: exportIncludeRedo,
            });

            if (exportCancelledRef.current) {
                return;
            }

            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            const fileName = exportProgrammeCode
                ? `${exportProgrammeCode}_Gradebook_${moment().format('YYYYMMDD')}.xlsx`
                : 'Gradebook.xlsx';

            link.href = url;
            link.setAttribute('download', fileName);

            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);

            setExportGenerating(false);
            setExportModalOpen(false);
        } catch (error) {
            if (exportCancelledRef.current) {
                return;
            }

            setExportGenerating(false);
            setExportError(error?.response?.data?.message || 'Something went wrong generating the export. Please try again.');
        }
    };

    const handleNavigation = (location, page, states) => {
        if (shouldBlockNavigation) {
            if (Swal.isVisible()) {
                return false;
            }
            Swal.fire({
                title: "Warning",
                text: "You Have Unsaved Changes Left! Do you want to save changes",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "No, Leave",
                confirmButtonText: "Yes, Save Changes",
            }).then((value) => {
                if (value.isConfirmed) {
                    Swal.fire({
                        title: "Please wait",
                        text: "Saving changes...",
                        allowOutsideClick: false,
                        onBeforeOpen: () => {
                            Swal.showLoading();
                            const values = {
                                modulesArr: updateValueArr,
                                id: [Number(queryProgrammeId)],
                                versionId :queryVersionId
                            };
                            updatePmcScoreCancelToken(values)
                                .then((res) => {
                                    setUpdateValueArr([]);
                                    Swal.fire({
                                        icon: "success",
                                        title: "Success",
                                        text: "Updated Successfully",
                                    }).then(() => {
                                        if (location) {
                                            history.push(location.pathname + (location.search || ""));
                                        } else if (!location && page) {
                                            if (page == "exempted") {
                                                handleExemption(...states)
                                            } else {
                                                setTableState((prevState) => ({
                                                    ...prevState,
                                                    page:
                                                        page === "firstPage"
                                                            ? 1
                                                            : page === "prevPage"
                                                                ? paginationState.currentPage - 1
                                                                : page === "nextPage"
                                                                    ? +paginationState.currentPage + 1
                                                                    : paginationState.lastPage,
                                                }));
                                            }
                                        }
                                    });
                                })
                                .catch((err) => {
                                    Swal.close(); // Close the "Saving changes..." popup if there was an error
                                    Swal.fire({
                                        icon: "error",
                                        title: "Error",
                                        text: `${err?.response?.data?.data || "Something went wrong"}`,
                                    });
                                });
                        },
                    });
                } else {
                    setUpdateValueArr([]);
                    if (location) {
                        history.push(location.pathname + (location.search || ""));
                    } else if (!location && page) {
                        if (page == "exempted") {
                            handleExemption(...states)
                        } else {
                            setTableState((prevState) => ({
                                ...prevState,
                                page:
                                    page === "firstPage"
                                        ? 1
                                        : page === "prevPage"
                                            ? paginationState.currentPage - 1
                                            : page === "nextPage"
                                                ? +paginationState.currentPage + 1
                                                : paginationState.lastPage,
                            }));
                        }
                    }
                }
            });

            return false; // Prevent the default navigation behavior
        } else if (page == "exempted") {
            handleExemption(...states)
        }
    };

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (shouldBlockNavigation) {
                event.preventDefault();
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [shouldBlockNavigation]);

    useEffect(() => {
        setLoading((prevState) => ({ ...prevState, heading: true }));
        const Values = {
            id: queryProgrammeId,
            versionId: queryVersionId
        };
        getProgramGradebookModuleList(Values)
            .then((res) => {
                setmoduleHeader(res.data?.getModuls);
                setLoading((prevState) => ({ ...prevState, heading: false }));
            })
            .catch((err) => {
                console.error("error", err);
                setLoading((prevState) => ({ ...prevState, heading: false }));
            });
    }, []);

    useEffect(() => {
        setLoading((prevState) => ({ ...prevState, list: true }));

        const payload = {
            id: queryProgrammeId,
            versionId: queryVersionId,
            key: "",
            sort: "DESC",
            exportStatus: "false",
            search: search,
            page: tableState.page,
            limit: tableState.limit,
            intake_year_number: intake.arr || [],
            graduation: graduated.arr || [],
            students: studentArr || [],
        }
        getProgrammeModulesGradeStudentList(payload)
            .then((res) => {
                let pagination = res?.data?.pagination;
                setIsCourseEdited(res?.data?.getCourse?.allUpdatedCourse)
                setUserData(res.data.data)
                setQualifications(res.data?.getQulification)
                setPaginationState({
                    from: pagination?.from,
                    to: pagination?.to,
                    total: pagination?.total,
                    perPage: pagination?.per_page,
                    currentPage: pagination?.current_page,
                    lastPage: pagination?.last_page,
                });
                setTooltipValues(res?.data?.getQulification);
                setLoading((prevState) => ({ ...prevState, list: false }));
            })
            .catch((err) => {
                console.error(err);
                setLoading((prevState) => ({ ...prevState, list: false }));
            });
    }, [updateData, queryProgrammeId, intake.arr, graduated.arr, search, tableState.page, tableState.limit]);

    useEffect(() => {
        const source = axios.CancelToken.source();

        const getFilters = async () => {
            try {
                const res = await getPMCFiltersCancelToken({ id: queryProgrammeId, versionId : queryVersionId }, source.token);
                if (res.status === 200) {
                    setFilterData(prev => ({
                        ...prev,
                        intake: res.data?.intakeFilters || [],
                        graduated: res.data?.graduatedFilter || [],
                    }));
                    setStudentArr(res.data?.students || []);
                }
            } catch (err) {
                if (axios.isCancel(err)) {
                    console.error("Filter request canceled:", err.message);
                } else {
                    console.error("Error fetching filters:", err);
                }
            }
        };

        if (queryProgrammeId) {
            getFilters();
        }

        return () => {
            source.cancel("Filter request canceled due to component unmount or id change");
        };
    }, [queryProgrammeId]);

    const handleSearchFilter = (e) => {
        const value = e.target.value;
        setDebouncedTerm(value);
    };

    const resetFilter = () => {
        // Clear the debounce timeout to prevent delayed search update
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        setDebouncedTerm("");
        setSearch(""); // Set search immediately to empty
        setIntake({ arr: [], checkObj: {} });
        setGraduated({ arr: [], checkObj: {} });
        setTableState((prevState) => ({ ...prevState, page: 1 }));
    };

    const handleExemption = (moduleId, studentId, isExempted, row) => {
        // 1. Update userData state
        const updatedUserData = userData.map(student => {
            if (student.id === studentId) {
                return {
                    ...student,
                    modules: student.modules.map(module => {
                        if (module.ModuleId === moduleId) {
                            return {
                                ...module,
                                courseGradeDetails: {
                                    ...module.courseGradeDetails,
                                    grant_exemption: isExempted ? 1 : 0,
                                },
                            };
                        }
                        return module;
                    }),
                };
            }
            return student;
        });
        setUserData(updatedUserData);

        // 2. Track the change in updateValueArr
        setUpdateValueArr(prev => {
            const updated = [...prev];
            const index = updated.findIndex(
                item => item.student_id === studentId && item.module_id === moduleId
            );

            if (index > -1) {
                updated[index] = {
                    ...updated[index],
                    grant_exemption: isExempted ? 1 : 0,
                };
            } else {
                updated.push({
                    student_id: studentId,
                    module_id: moduleId,
                    grant_exemption: isExempted ? 1 : 0,
                    pmc_id: queryProgrammeId,
                    qid: row?.qualification,
                    intake_id: row?.courseGradeDetails?.intake_id || ""
                });
            }
            const updatedGradeData = updated.map(item => ({ ...item, version_id: queryVersionId }));
            return updatedGradeData;
        });
    };

    const exportData = (fileType, fileName) => {
        const Values = {
            id: queryProgrammeId,
            versionId: queryVersionId,
            key: "",
            sort: "DESC",
            exportStatus: "false",
            search: search,
            page: tableState.page,
            limit: tableState.limit,
            intake_year_number: intake.arr || [],
            graduation: graduated.arr || [],
            students: studentArr || [],
        };

        getProgrammeModulesGradeStudentList(Values)
            .then((res) => {
                const respData = res?.data?.data;
                const header = [
                    "Student Name",
                    "Student Number",
                    "Original Qualification",
                    "Latest Intake",
                    "Module Name",
                    "Module Grade",
                    "Module Result",
                    "Module Intake",
                    "Programme Grade",
                    "Programme Result",
                ];
                const data = [];

                respData.map((item) => {
                    let dataItem = {
                        "Student Name": `${item.full_name}`,
                        "Student Number": item?.student_num || item?.student_crm_id,
                        "Original Qualification": item.getOriginIntake?.split("-").slice(0, 2).join("-") || "N/A",
                        "Latest Intake": item?.getLatestEnrolment?.split("-").slice(0, 2).join("-") || "N/A",
                        "Module Name": "",
                        "Module Grade": "",
                        "Module Result": "",
                        "Module Intake": "",
                        "Programme Grade": (item?.programCalculate
                            ? (() => {
                                const calc = item.programCalculate;
                                if (calc?.pass_status === "N/A") {
                                    return "Pending Calculation";
                                }
                                if (calc?.pass_status === "N/A" && (calc?.scoreRecieved !== "N/A" || !calc?.gradeText)) {
                                    return "N/A";
                                }
                                return percentageView
                                    ? ((calc.scoreRecieved !== undefined && calc.scoreRecieved !== "N/A") || calc.scoreRecieved === 0)
                                        ? typeof calc.scoreRecieved === "number"
                                            ? calc.scoreRecieved % 1 === 0 ? `${calc.scoreRecieved}%` : `${calc.scoreRecieved.toFixed(2)}%`
                                            : typeof calc.scoreRecieved === "string"
                                                ? calc.scoreRecieved.includes("%")
                                                    ? parseFloat(calc.scoreRecieved % 1 === 0 ? `${calc.scoreRecieved}%` : `${calc.scoreRecieved.toFixed(2)}%`)
                                                    : parseFloat(calc.scoreRecieved % 1 === 0 ? `${calc.scoreRecieved}%` : `${calc.scoreRecieved.toFixed(2)}%`)
                                                : "N/A"
                                        : "N/A"
                                    : calc.grading_type !== 3
                                        ? typeof calc.gradeText === "string" && calc.gradeText.includes("%")
                                            ? (parseFloat(calc.gradeText) % 1 === 0 ? parseFloat(calc.gradeText) : parseFloat(calc.gradeText).toFixed(2)) + "%"
                                            : typeof calc.gradeText === "number"
                                                ? (calc.gradeText % 1 === 0 ? calc.gradeText : calc.gradeText.toFixed(2)) + "%"
                                                : calc.gradeText || "N/A"
                                        : `${calc.programeAssMark} / ${calc.programeAssTotalMark}`;
                            })()
                            : "N/A"),
                        "Programme Result": item?.programCalculate?.pass_status === "N/A"
                            ? "Pending Calculation"
                            : RenderQuizAttemptResultStatus(item?.programCalculate?.pass_status)?.text || "N/A",
                    };
                    data.push(dataItem);

                    item.modules &&
                        item.modules.map((moduleItem, index) => {
                            const gradeText1 = moduleItem?.courseGradeDetails?.scoreRecieved;
                            const gradeText2 = moduleItem?.courseGradeDetails?.gradeText;
                            const statusAvailable = moduleItem?.courseGradeDetails?.pass_status && moduleItem?.courseGradeDetails?.pass_status !== "N/A";
                            const gradeAvailable = ((gradeText1 && gradeText1 !== "N/A") || (gradeText2 && gradeText2 !== "N/A"));

                            let moduleGrade = "N/A";

                            if (moduleItem?.grant_exemption) {
                                moduleGrade = "Exempted";
                            } else if (!moduleItem?.courseGradeDetails || moduleItem.courseGradeDetails.length === 0) {
                                moduleGrade = "Not Enrolled";
                            } else if (!statusAvailable) {
                                moduleGrade = "Pending Calculation";
                            } else if (statusAvailable && (gradeText1 && gradeText1 !== "N/A")) {
                                moduleGrade = `${Math.round(parseFloat(gradeText1))}%`;
                            } else if (statusAvailable && (gradeText2 && gradeText2 !== "N/A")) {
                                moduleGrade = gradeText2;
                            } else {
                                moduleGrade = "N/A";
                            }

                            let moduleResult = "N/A";
                            if (moduleItem?.grant_exemption) {
                                moduleResult = "Exempted";
                            } else if (!moduleItem?.courseGradeDetails || moduleItem.courseGradeDetails.length === 0) {
                                moduleResult = "Not Enrolled";
                            } else if (!statusAvailable) {
                                moduleResult = "Pending Calculation";
                            } else if (statusAvailable && gradeAvailable) {
                                moduleResult = RenderQuizAttemptResultStatus(moduleItem?.courseGradeDetails?.pass_status)?.text || "N/A";
                            } else {
                                moduleResult = "N/A";
                            }

                            let moduleIntake = "N/A";
                            if (moduleItem?.grant_exemption) {
                                moduleIntake = "Exempted";
                            } else if (!moduleItem?.courseGradeDetails || moduleItem.courseGradeDetails.length === 0) {
                                moduleIntake = "Not Enrolled";
                            } else if (!statusAvailable) {
                                moduleIntake = "Pending Calculation";
                            } else if ((statusAvailable && gradeAvailable) && moduleItem?.courseGradeDetails?.intakes_number_year) {
                                moduleIntake = moduleItem.courseGradeDetails.intakes_number_year;
                            } else {
                                moduleIntake = "N/A";
                            }

                            const subDataItem = {
                                "Student Name": "",
                                "Student Number": "",
                                "Module Name": moduleHeader[index]?.Portal || "",
                                "Module Grade": moduleGrade,
                                "Module Result": moduleResult,
                                "Module Intake": moduleIntake,
                            };
                            data.push(subDataItem);
                        });
                });

                if (fileType === "csv") {
                    const csvString = Papa.unparse({ fields: header, data });
                    const blob = new Blob([csvString], {
                        type: "text/csv;charset=utf-8,",
                    });

                    const blobURL = window.URL.createObjectURL(blob);
                    const anchor = document.createElement("a");
                    anchor.download = fileName;
                    anchor.href = blobURL;
                    anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href].join(":");
                    anchor.click();

                    setTimeout(() => {
                        URL.revokeObjectURL(blobURL);
                    }, 1000);
                    Swal.close();
                } else if (fileType === "xlsx") {
                    const compatibleData = data.map((row) => {
                        const obj = {};
                        header.map((col) => {
                            obj[col] = row[col];
                        });
                        return obj;
                    });

                    let wb = XLSX.utils.book_new();
                    let ws1 = XLSX.utils.json_to_sheet(compatibleData, { header });
                    XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
                    XLSX.writeFile(wb, `${fileName}.xlsx`);
                    Swal.close();
                    return false;
                }

                if (fileType === "pdf") {
                    const compatibleData = data.map((row) => {
                        return [
                            row["Student Name"],
                            row["Student Number"],
                            row["Original Qualification"],
                            row["Latest Intake"],
                            row["Module Name"],
                            row["Module Grade"],
                            row["Module Result"],
                            row["Module Intake"],
                            row["Programme Grade"],
                            row["Programme Result"],
                        ];
                    });
                    const doc = new JsPDF();
                    doc.autoTable({
                        head: [header],
                        body: compatibleData,
                        styles: {
                            minCellHeight: 10,
                            minCellWidth: 5,
                            halign: "left",
                            fontSize: 8,
                        },
                    });
                    doc.save(`${fileName}.pdf`);
                    Swal.close();
                    return false;
                }
            })
            .catch((err) => console.error(err));
    };

    const exportXlsxData = async (fileName, courseName) => {
        try {
            const Values = {
                id: queryProgrammeId,
                versionId: queryVersionId,
                key: "",
                sort: "DESC",
                exportStatus: "false",
                search: search,
                page: tableState.page,
                limit: tableState.limit,
                intake_year_number: intake.arr || [],
                graduation: graduated.arr || [],
                students: studentArr || [],
            };

            const res = await getProgrammeModulesGradeStudentList(Values);

            if (res?.status == 200) {
                const respData = res?.data?.data || [];
                const header = [
                    "Name",
                    "Surname",
                    "ID Number",
                    "Student Number",
                    "Original Qualification",
                    "Latest Intake",
                    ...moduleHeader.map((module) => module?.Portal),
                    "Programme Grade",
                    "Programme Result"
                ];

                const data = respData?.flatMap((item) => {
                    const moduleValues = moduleHeader.map((module) => {
                        let moduleData = item.modules.find(
                            (row) => row.ModuleId === module?.ModuleId
                        );

                        // Handle missing module data
                        if (!moduleData) return "N/A";

                        // Handle Exemption
                        if (moduleData.grant_exemption) return "Exempted";
                        if ((!moduleData?.courseGradeDetails || moduleData.courseGradeDetails.length === 0)) return "Not Enrolled"

                        // If pass_status or gradeText is missing or N/A, return "N/A"
                        const gradeText1 = moduleData?.courseGradeDetails?.scoreRecieved;
                        const gradeText2 = moduleData?.courseGradeDetails?.gradeText;
                        const pStatus = moduleData?.courseGradeDetails?.pass_status;

                        // If pass status is missing or "N/A", return "N/A"
                        if (!pStatus || pStatus === "N/A") {
                            return "Pending Calculation";
                        }

                        // If either gradeText1 or gradeText2 is valid
                        if ((gradeText1 == undefined || gradeText1 == "N/A") && (gradeText2 == undefined || gradeText2 == "N/A")) {
                            return "N/A";
                        }

                        // Score
                        const score = (moduleData?.courseGradeDetails?.scoreRecieved !== "N/A" && moduleData?.courseGradeDetails?.scoreRecieved !== undefined)
                            ? `${Math.round(parseFloat(moduleData.courseGradeDetails.scoreRecieved))}%`
                            : moduleData?.courseGradeDetails?.gradeText ?? "N/A";

                        // Pass Status
                        const passStatus = moduleData?.courseGradeDetails?.pass_status
                            ? RenderQuizAttemptResultStatus(moduleData?.courseGradeDetails?.pass_status)?.text
                            : "N/A";
                        
                        // Intake
                        const intake = moduleData?.courseGradeDetails?.intakes_number_year || "N/A";

                        // Combine into one cell
                        return `${intake}, ${score}, ${passStatus}`;
                    });

                    const rowData = [
                        item.first_name,
                        item.last_name,
                        item?.number || "Not Enrolled",
                        item?.student_crm_id || item?.student_num || "-",
                        item?.getOriginIntake?.split("-").slice(0, 2).join("-") || "-",
                        item?.getLatestEnrolment?.split("-").slice(0, 2).join("-") || "-",
                        ...moduleValues,
                        (item?.programCalculate
                            ? (() => {
                                const calc = item.programCalculate;
                                // Show N/A first if pass_status is N/A and score or grade conditions met
                                if (calc?.pass_status === "N/A") {
                                    return "Pending Calculation";
                                }
                                if (calc?.pass_status === "N/A" && (calc?.scoreRecieved !== "N/A" || !calc?.gradeText)) {
                                    return "N/A";
                                }
                                return percentageView
                                    ? ((calc.scoreRecieved !== undefined && calc.scoreRecieved !== "N/A") || calc.scoreRecieved === 0)
                                        ? typeof calc.scoreRecieved === "number"
                                            ? calc.scoreRecieved % 1 === 0 ? `${calc.scoreRecieved}%` : `${calc.scoreRecieved.toFixed(2)}%`
                                            : typeof calc.scoreRecieved === "string"
                                                ? calc.scoreRecieved.includes("%")
                                                    ? parseFloat(calc.scoreRecieved % 1 === 0 ? `${calc.scoreRecieved}%` : `${calc.scoreRecieved.toFixed(2)}%`)
                                                    : parseFloat(calc.scoreRecieved % 1 === 0 ? `${calc.scoreRecieved}%` : `${calc.scoreRecieved.toFixed(2)}%`)
                                                : "N/A"
                                        : "N/A"
                                    : calc.grading_type !== 3
                                        ? typeof calc.gradeText === "string" && calc.gradeText.includes("%")
                                            ? (parseFloat(calc.gradeText) % 1 === 0 ? parseFloat(calc.gradeText) : parseFloat(calc.gradeText).toFixed(2)) + "%"
                                            : typeof calc.gradeText === "number"
                                                ? (calc.gradeText % 1 === 0 ? calc.gradeText : calc.gradeText.toFixed(2)) + "%"
                                                : calc.gradeText || "N/A"
                                        : `${calc.programeAssMark} / ${calc.programeAssTotalMark}`;
                            })()
                            : "N/A"),
                        item?.programCalculate?.pass_status === "N/A"
                            ? "Pending Calculation"
                            : RenderQuizAttemptResultStatus(item?.programCalculate?.pass_status)?.text || "N/A",
                    ];

                    return [rowData];
                });

                const wb = new ExcelJS.Workbook();
                const ws = wb.addWorksheet('Excel Data');

                // Set border for the entire worksheet
                ws.views = [
                    {
                        state: 'frozen',
                        ySplit: 1,
                        xSplit: 1
                    },
                ];
                ws.properties.showGridLines = true;

                const columnStyles = [];
                header.forEach((col) => {
                    const style = {};
                    if (['Name', 'Surname', 'ID Number', 'Student Number', 'Original Qualification', 'Latest Intake'].includes(col)) {
                        style.font = { bold: true };
                        style.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFDBDBDB' }, // Light gray background color
                        };
                        style.border = {
                            top: { style: 'thin', color: { argb: 'FF000000' } },
                            bottom: { style: 'thin', color: { argb: 'FF000000' } },
                            left: { style: 'thin', color: { argb: 'FF000000' } },
                            right: { style: 'thin', color: { argb: 'FF000000' } }
                        };
                    } else if (col === 'Final Mark') {
                        style.font = { color: { argb: "FFFFFF" } };
                        style.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FF7030A0' }, // Purple background color
                        };
                        style.border = {
                            top: { style: 'thin', color: { argb: 'FF000000' } },    // Black top border
                            bottom: { style: 'thin', color: { argb: 'FF000000' } }, // Black bottom border
                            left: { style: 'thin', color: { argb: 'FF000000' } },   // Black left border
                            right: { style: 'thin', color: { argb: 'FF000000' } }   // Black right border
                        };
                    } else {
                        style.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFDBDBDB' }, // Light gray background color
                        };
                        style.border = {
                            top: { style: 'thin', color: { argb: 'FF000000' } },
                            bottom: { style: 'thin', color: { argb: 'FF000000' } },
                            left: { style: 'thin', color: { argb: 'FF000000' } },
                            right: { style: 'thin', color: { argb: 'FF000000' } }
                        };
                    }
                    columnStyles.push(style);
                });
                const staticRow = ws.addRow([courseName, '', '', '', '']);
                staticRow.height = 16;
                staticRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF66CCFF' } };
                staticRow.getCell(1).font = { bold: true };
                staticRow.getCell(1).alignment = { horizontal: 'center', vertical: "bottom" };
                staticRow.getCell(1).border = {};
                staticRow.getCell(5).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF203764' } };
                ws.mergeCells(`A${staticRow.number}:D${staticRow.number}`);

                const headerRow = ws.addRow(header);
                headerRow.eachCell((cell, colNumber) => {
                    if (columnStyles[colNumber - 1].font) {
                        cell.font = columnStyles[colNumber - 1].font;
                    }
                    cell.fill = columnStyles[colNumber - 1].fill;
                    cell.border = columnStyles[colNumber - 1].border;
                });

                data.forEach((row) => {
                    const dataRow = ws.addRow(row);
                    dataRow.eachCell((cell, colNumber) => {
                        cell.border = columnStyles[colNumber - 1].border;
                    });
                });

                const buffer = await wb.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                a.download = `${fileName}.xlsx`;
                a.click();
            }

            Swal.close();
        } catch (err) {
            console.error(err);
            Swal.close();
            Swal.fire("Error", "Failed to export data", "error");
        }
    };

    const slider = document.querySelector(".table-book-mid");

    useEffect(() => {
        if (slider) {
            let mouseDown = false;
            let startX, scrollLeft;

            let startDragging = function (e) {
                mouseDown = true;
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            };
            let stopDragging = function (event) {
                mouseDown = false;
            };

            slider.addEventListener("mousemove", (e) => {
                e.preventDefault();
                if (!mouseDown) {
                    return;
                }
                const x = e.pageX - slider.offsetLeft;
                const scroll = x - startX;
                slider.scrollLeft = scrollLeft - scroll;
            });

            // Add the event listeners
            slider.addEventListener("mousedown", startDragging, false);
            slider.addEventListener("mouseup", stopDragging, false);
            slider.addEventListener("mouseleave", stopDragging, false);
        }
    }, [slider,tableWidth]);

    const handleResize = () => {
        let pageWidth = document.querySelector(
            ".my-tickets-info-list"
        )?.offsetWidth;
        setTableWidth(pageWidth);
    };

    useEffect(() => {
        var resizeRequested = false;
        handleResize();
        window.addEventListener(
            "resize",
            function () {
                if (!resizeRequested) {
                    resizeRequested = true;
                    window.requestAnimationFrame(function () {
                        setTableWidth(
                            document.querySelector(".my-tickets-info-list")?.clientWidth
                        );
                        resizeRequested = false;
                    });
                }
            },
            100
        );
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleSaveGrades = (studentID) => {
        Swal.fire({
            title: "Updating",
            onOpen: function () {
                Swal.showLoading();
            },
        });
        setSaveGradesLoading(true);
        const values = {
            intake_id: queryProgrammeId,
            courses: updateValueArr,
            student_id: studentID,
        };
        if (!studentID) {
            delete values.student_id;
        }
        updateCousesScore(values)
            .then((res) => {
                setSaveGradesLoading(false);
                if (studentID) {
                    const filteredArr = updateValueArr.filter(
                        (item) => item.student_id !== studentID
                    );
                    setUpdateValueArr(filteredArr);
                } else {
                    setUpdateValueArr([]);
                }
                Swal.close();
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Updated Successfully",
                }).then((res) => setUpdateData(!updateData));
            })
            .catch((err) => {
                setSaveGradesLoading(false);
                Swal.close();
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: `${err?.response?.data?.data}`,
                });
            });
    };

    const handleGradeCalculation = (studentID) => {
        Swal.fire({
            title: "Calculating Final Grades",
            onOpen: function () {
                Swal.showLoading();
            },
        });
        setSaveGradesLoading(true);
        const values = {};

        if (updateValueArr?.length) {
            let newUpdateValueArr = [...updateValueArr];
            if (studentID) {
                newUpdateValueArr = newUpdateValueArr.filter(item => item.student_id == studentID);
            }
            values.modulesArr = newUpdateValueArr;
        }
        values.id = [Number(queryProgrammeId)];
        values.versionId= queryVersionId

        if (studentID) {
            values.student_id = studentID;
        }
        updatePmcScoreCancelToken(values)
            .then((res) => {
                setSaveGradesLoading(false);
                setUpdateValueArr([]);
                Swal.close();
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Updated Successfully",
                }).then((res) => setUpdateData(!updateData));
            })
            .catch((err) => {
                setSaveGradesLoading(false);
                Swal.close();
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: `${err?.response?.data?.data || "someting went wrong"}`,
                });
            });
    };

    const handleSaveSingleGrade = (stdId) => {
        let otherIds = stdIds.filter((item) => item !== stdId);
        if (otherIds.length) {
            Swal.fire({
                title: "Are You Sure?",
                text: "You have unsaved data in other students",
                icon: "warning",
                showCancelButton: false,
                showConfirmButton: false,
                html: `
          <div class="custom-swal-button">
            <p>You have unsaved data in other students!</p>
            <button class="swal2-confirm swal2-styled" onclick='triggerSwall({type: "saveAll", updatedArr: ${JSON.stringify(
                    updateValueArr
                )}})' >Save All</button>
            <button class="swal2-confirm swal2-styled" onclick='triggerSwall({type: "save", stdId: ${stdId}, updatedArr: ${JSON.stringify(
                    updateValueArr
                )}})'>Save</button>
            <button class="swal2-cancel swal2-styled" onclick="triggerSwall({type: 'cancel'})" style="background-color: rgb(221, 51, 51);">Cancel</button>
          </div>`,
            });
        } else {
            handleGradeCalculation(stdId);
        }
    };

    const checkbtnValue = (values) => {
        if (values.type === "saveAll") {
            handleSaveGrades(undefined, values.updatedArr);
        } else if (values.type === "save") {
            handleSaveGrades(values.stdId, values.updatedArr);
        }
        Swal.close();
    };

    return (
        <>
            {exportModalOpen && (
                <ModalOverlay>
                    <ModalContainer role="dialog" aria-modal="true">
                        <CloseButton
                            type="button"
                            onClick={closeExportModal}
                        >
                            <i className="fal fa-times"></i>
                        </CloseButton>
                        <ModalHeader>
                            <ModalTitle>Export Grade Reports</ModalTitle>
                            <ModalDescription>
                                This exports a report of student grades from the selected intake origins along the study path. It reads the gradebook and may take a minute to finish. Please keep this window open until the export is complete.
                            </ModalDescription>
                            <FieldGroup>
                                <FieldLabel>Include Origin Intakes</FieldLabel>
                                <Select
                                    isMulti
                                    isDisabled={exportGenerating}
                                    isLoading={exportIntakeLoading}
                                    isClearable={false}
                                    options={exportIntakeOptions}
                                    value={exportSelectedIntakes}
                                    components={{ MultiValueRemove }}
                                    onChange={(selected) => setExportSelectedIntakes(selected || [])}
                                    placeholder="Select intakes..."
                                    styles={multiSelectStyles}
                                />
                            </FieldGroup>
                            <TogglesRow>
                                <ToggleContainer>
                                    <ToggleButton
                                        size="md"
                                        checked={exportIncludeNonWeighted}
                                        disabled={exportGenerating}
                                        label="Include non-weighted assessments"
                                        onChange={() => setExportIncludeNonWeighted((value) => !value)}
                                    />
                                </ToggleContainer>

                                <ToggleContainer>
                                    <ToggleButton
                                        size="md"
                                        checked={exportIncludeRedo}
                                        disabled={exportGenerating}
                                        label="Include Redo Module Sheet"
                                        onChange={() => setExportIncludeRedo((value) => !value)}
                                    />
                                </ToggleContainer>
                            </TogglesRow>

                            {exportError && <ErrorMessage>{exportError}</ErrorMessage>}
                        </ModalHeader>
                        <ModalFooter>
                            <Button
                                type="button"
                                variant="primary"
                                disabled={!exportSelectedIntakes.length || exportGenerating}
                                onClick={handleGenerateExport}
                            >
                                {exportGenerating ? 'Generating…' : 'Generate Export'}
                            </Button>
                            <CancelButton type="button" onClick={closeExportModal}>
                                <i className="fal fa-times"></i> Cancel
                            </CancelButton>
                        </ModalFooter>
                    </ModalContainer>
                </ModalOverlay>
            )}
            <Prompt when={!!shouldBlockNavigation} message={handleNavigation} />
            <div className="my-tickets-info-list Tickets-main-wrap course-gradebook">
                <div className="l-o-c-t custom-table-div filter-search-icon card card-table-custom">
                    <div className="search-filter-div">
                        <div className="search-filter-div-left">
                            <div className="system-administration-table table-responsive">
                                <div className="table-responsive-div">
                                    <div
                                        id="assessment-table-main_wrapper"
                                        className="dataTables_wrapper no-footer"
                                    >
                                        <div
                                            id="assessment-table-main_filter"
                                            className="dataTables_filter"
                                        >
                                            <label>
                                                <input
                                                    type="search"
                                                    className=""
                                                    placeholder="Search"
                                                    aria-controls="assessment-table-main"
                                                    onChange={handleSearchFilter}
                                                    value={debouncedTerm}
                                                />
                                            </label>
                                            <div className="filter-eff filter-data-btn">
                                                <button className="filter-buttons">
                                                    <i className="fal fa-filter"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="filter-button-group">
                                    <div className="filter-scroll">
                                        <div className={`filter-scroll-inner filter-custom-new`}>
                                            <Tablefilter
                                                filterName="Intake"
                                                optionArr={filterData.intake}
                                                state={intake}
                                                setState={setIntake}
                                            />
                                            <Tablefilter
                                                filterName="Graduated"
                                                optionArr={filterData.graduated}
                                                state={graduated}
                                                setState={setGraduated}
                                            />
                                        </div>
                                    </div>
                                    <div className="button-reset dropdown-comman">
                                        <button
                                            className="btn btn-primary"
                                            title="Reset"
                                            onClick={resetFilter}
                                        >
                                            <i className="fal fa-redo"></i>Reset
                                        </button>
                                    </div>
                                    <div className="files-export-group">
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportXlsxData(
                                                    `${props?.versionData?.name} Grade Book`,
                                                    props?.versionData?.name
                                                );
                                            }}
                                            title="Export spreadsheet"
                                        >
                                            <i className="fal fa-file-excel icon"></i>
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("csv", `${props?.versionData?.name} Grade Book`);
                                            }}
                                            title="Export CSV"
                                        >
                                            <i className="fal fa-file-csv icon"></i>
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-files"
                                            onClick={() => {
                                                exportData("pdf", `${props?.versionData?.name} Grade Book`);
                                            }}
                                            title="Export PDF"
                                        >
                                            <i className="fal fa-file-pdf icon"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="search-filter-div-right">
                            <div className=" filter-search-bar-blk">
                                <div className="add-ticket-blk button-reset dropdown-comman d-flex align-items-start gap-3">
                                   <PermissionsGate
                                        scopes={["pmcgradebookexport"]}
                                        errorProps={{ disabled: true, title: "You do not have permission to access this function" }}
                                    >
                                        <Button
                                            type="button"
                                            variant="secondary"
                                            title="Export Grade Report"
                                            onClick={openExportModal}
                                        >
                                            <i className="fal fa-bar-chart"></i>
                                            Export Grade Report
                                        </Button>
                                   </PermissionsGate>
                                    <div className="d-flex flex-column">
                                        <button
                                            className="btn btn-primary"
                                            title="Calculate Final Grades"
                                            onClick={() => handleGradeCalculation()}
                                        >
                                            <i className="fal fa-sync"></i>
                                            Calculate Final Grades
                                        </button>

                                        {qualifications?.grade_update_datetime && qualifications?.updatedby_name && <div className='document_wrp align-items-start pt-2'>
                                            <i className="fal fa-history history_btn pr-2" />
                                            <small>
                                                <span>
                                                    Updated on <strong>{moment(qualifications.grade_update_datetime).format('DD MMM YY')}</strong>{" "}
                                                    at <strong>{moment(qualifications.grade_update_datetime).format('HH:mm')}</strong>{" "}
                                                    by <strong>{qualifications.updatedby_name}</strong>
                                                </span>
                                            </small>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading.heading || loading.list ? (
                        <SkeletonTicketList />
                    ) : userData?.length ? (
                        <div className="table-book-responsive">
                            <div className="table-book pmc-module-gradebook row m-0">
                                <div className={"table-book-left d-flex"}>
                                    <table className="table-book-main" >
                                        <thead>
                                            <tr>
                                                <th>Student</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userData?.length > 0 && userData?.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <div className="assigned-title-block-new">
                                                            <div className="assigned-title-itm">
                                                                <span
                                                                    className={
                                                                        "assigned-title-blk  name-icon cat-dark-red " +
                                                                        ColorRender(item.role_name)
                                                                    }
                                                                >
                                                                    {item.picture_me ? (
                                                                        <img
                                                                            src={`${IMAGE_URL}/${encodeURI(item.picture_me
                                                                                .replace("public/", "")
                                                                                .replaceAll(
                                                                                    "/home/myaie/public_html/",
                                                                                    ""
                                                                                ))}`}
                                                                            alt="AIE"
                                                                        />
                                                                    ) : (
                                                                        InitialRender(
                                                                            item?.full_name
                                                                                ? item.full_name.split(" ").concat(["", ""]).slice(0, 2)
                                                                                : null
                                                                        )
                                                                    )}
                                                                    <span
                                                                        className={`profile-box-2-status ${item.activity_status
                                                                            ? item.activity_status.toLowerCase() ==
                                                                                "online"
                                                                                ? "Online"
                                                                                : item.activity_status.toLowerCase() ==
                                                                                    "away"
                                                                                    ? "Away"
                                                                                    : "Offline"
                                                                            : "Offline"
                                                                            }`}
                                                                    >
                                                                        <i className="fas fa-circle"></i>
                                                                    </span>
                                                                    <Hover
                                                                        firstName={item.full_name.split(" ")[0]}
                                                                        lastName={
                                                                            item.full_name.split(" ").length
                                                                                ? item.full_name.split(" ")[1]
                                                                                : ""
                                                                        }
                                                                        photo={item.picture_me}
                                                                        email={item.email}
                                                                        mobile={item.mobile}
                                                                        status={item.status}
                                                                        activity_status={item.activity_status}
                                                                        showNumber={true}
                                                                        number={item.student_crm_id}
                                                                        right={true}
                                                                    />
                                                                </span>
                                                                <PermissionsGate
                                                                    scopes={["casvview"]}
                                                                    RenderError={() => (
                                                                        <p title={item.full_name}>
                                                                            {item.full_name}
                                                                        </p>
                                                                    )}
                                                                >
                                                                    <Link
                                                                        className="as-text-blue curser "
                                                                        to={`/studentAdministration/students/open/${item?.id}/gradebook`}
                                                                    >
                                                                        <span className="" title={item.full_name}>
                                                                            {item.full_name}
                                                                        </span>
                                                                    </Link>
                                                                </PermissionsGate>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <table className="table-book-main">
                                        <thead>
                                            <tr>
                                                <th>Original Qualification</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userData?.length > 0 && userData?.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item?.qualification_redirection_id && item?.getOriginIntake?.length ?
                                                        <Link
                                                            className="as-text-blue curser"
                                                            title={item.getOriginIntake?.split("-").slice(0, 2).join("-")}
                                                            to={`/courseAdministration/Programmes/programme/open/${item?.qualification_redirection_id}/details`}
                                                        >
                                                            {item.getOriginIntake?.split("-").slice(0, 2).join("-")}
                                                        </Link>
                                                        : "-"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <table className="table-book-main">
                                        <thead>
                                            <tr>
                                                <th>Latest Intake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userData?.length > 0 && userData?.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        {(() => {
                                                            
                                                            const enrol = item?.getLatestEnrolment;
                                                            if (!enrol) return "-";

                                                            const parts = enrol.split("-");
                                                            if (parts.length < 3) return "-";

                                                            const intakeLabel = parts.slice(0, 2).join("-");  // "2020-2"
                                                            const studentId = parts[2];                       // "11499"

                                                            const linkTo = `/studentadministration/registration/open/registration?studentId=${studentId}&studentName=${item?.full_name}`;

                                                            return (
                                                                <p className="mb-0" title={intakeLabel} >
                                                                    {intakeLabel}
                                                                </p>
                                                            );
                                                        })()}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div
                                    className={
                                        "table-book-mid " +
                                        (percentageView
                                            ? moduleHeader?.length < 9
                                                ? "less-items"
                                                : "overflow-auto"
                                            : moduleHeader?.length < 9
                                                ? "less-items"
                                                : "overflow-auto")
                                    }
                                >
                                    <div className="grade-acc">
                                        <div className={"grade-acc-in active"}>
                                            <table className="table-book-main table-book-main-contetn">
                                                <thead>
                                                    <tr>
                                                        {moduleHeader?.length
                                                            ? moduleHeader.map((item, index) => (
                                                                <th key={index}>
                                                                    <div className="tb-book-tit" style={{width: "fit-content"}}>
                                                                        <Link
                                                                            className="curser"
                                                                            target="_blank"
                                                                            to={`/program-management-center/modules/module/open/${item?.ModuleId}`}
                                                                            title={item?.Portal}
                                                                        >
                                                                            <p>
                                                                                {TrimText(item?.Portal, 20)}
                                                                            </p>
                                                                        </Link>
                                                                    </div>
                                                                </th>
                                                            ))
                                                                : (<tr><th></th></tr>)}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {userData?.length > 0 ? userData?.map((item, i) => (
                                                        <tr key={i}>
                                                            {item?.modules?.length > 0 ? item?.modules?.map((module, index) => {
                                                                const grantExemption = module?.courseGradeDetails?.grant_exemption;
                                                                const isExempted = grantExemption == 1 || grantExemption === true;
                                                                const isNotEnrolled = !(
                                                                    module?.courseGradeDetails &&
                                                                    Object.keys(module.courseGradeDetails).length > 0 &&
                                                                    ((module?.courseGradeDetails?.pass_status && module?.courseGradeDetails?.pass_status !== "N/A") &&
                                                                        (module?.courseGradeDetails?.scoreRecieved != "N/A" && module?.courseGradeDetails?.gradeText !== "N/A"))
                                                                );

                                                                // alignment rules
                                                                const isLastColumn = index === moduleHeader.length - 1;

                                                                const baseAlign = (isNotEnrolled || isExempted)
                                                                    ? "justify-content-center"
                                                                    : "justify-content-start";

                                                                const alignClass = isLastColumn
                                                                    ? `justify-content-start fit-content pl-3`
                                                                    : baseAlign;
                                                                const courseGradeDetails = module?.courseGradeDetails;
                                                                return (
                                                                    <td key={index} className="">
                                                                        <div className={`d-flex h-100 align-items-center ${alignClass}`}>
                                                                            {(courseGradeDetails && Object.keys(courseGradeDetails).length > 0) ? <> {
                                                                                grantExemption ? (<>
                                                                                    <span
                                                                                        className="as-widget-text grade-info-green curser d-flex flex-column align-items-center justify-content-end"
                                                                                        title="Remove Exemption"
                                                                                        onClick={() => {
                                                                                            handleExemption(module?.ModuleId, item?.id, courseGradeDetails?.grant_exemption == 0 ? 1 : 0, module);
                                                                                        }}
                                                                                    >
                                                                                        <i className="fal fa-user-plus as-text-widget mb-1"></i>
                                                                                        <div className="exempted-text as-text-widget">
                                                                                            Exempted <i className="fal fa-info-circle pl-1"></i>
                                                                                        </div>
                                                                                    </span>
                                                                                </>) : (courseGradeDetails?.pass_status !== "N/A" && courseGradeDetails?.scoreRecieved !== "N/A" && courseGradeDetails?.gradeText !== "N/A") ? (<>
                                                                                    <Link
                                                                                        target="_blank"
                                                                                        to={`/courseAdministration/coursesdetails/${courseGradeDetails?.intake_id}/gradeBooks/show`}
                                                                                        className="d-flex align-items-center mod-intake align-self-baseline fontsize-12" title="intake">
                                                                                        {module?.courseGradeDetails?.intakes_number_year ? <i className="fa-solid fa-rectangle-history-circle-user mr-1 text-primary me-2"></i> : <span></span>}
                                                                                        <span className="text-primary fw-medium text-xs text-nowrap" title={module?.courseGradeDetails?.intakes_number_year}>
                                                                                            {module?.courseGradeDetails?.intakes_number_year}
                                                                                        </span>
                                                                                    </Link>
                                                                                    <div className="d-flex align-items-end h-100">
                                                                                        <div className="d-flex align-items-center">
                                                                                            <div className="d-flex align-items-center justify-content-center ml-1 mr-2">
                                                                                                <div className="d-flex flex-column align-items-center text-center">
                                                                                                    {module?.courseGradeDetails?.pass_status ? RenderQuizAttemptResultStatus(module?.courseGradeDetails?.pass_status)?.html : <span className="empty-status">N/A</span>}
                                                                                                    <span className={`as-text-widget ${module?.courseGradeDetails?.pass_status && 'mt-1'}`}>
                                                                                                        {(() => {
                                                                                                            const item = module?.courseGradeDetails;
                                                                                                            if (item?.scoreRecieved && item?.scoreRecieved !== "N/A" || item?.scoreRecieved === 0) {
                                                                                                                // Score received exists and is valid, or it's 0
                                                                                                                return typeof item?.scoreRecieved === "string" && item?.scoreRecieved.includes("%")
                                                                                                                    ? Math.round(parseFloat(item?.scoreRecieved.replace("%", ""))) + "%"
                                                                                                                    : item?.grading_type !== 3
                                                                                                                        ? (typeof item?.gradeText === "string" && item?.gradeText.includes("%")
                                                                                                                            ? Math.round(parseFloat(item?.gradeText.replace("%", ""))) + "%"
                                                                                                                            : typeof item?.gradeText === "number"
                                                                                                                                ? item?.gradeText + "%"
                                                                                                                                : item?.gradeText) || "N/A"
                                                                                                                        : twoDecimalRound(item?.getAssessmentCalculate_sum_ass_mark) + " / " + item?.getAssessmentCalculate_sum_ass_total_mark;
                                                                                                            } else {
                                                                                                                // When scoreRecieved is "N/A" or undefined, return "N/A" with a class
                                                                                                                return <span className="empty-status">N/A</span>;
                                                                                                            }
                                                                                                        })()}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>

                                                                                            <div
                                                                                                className="as-widget-text grade-info-red curser d-flex align-items-center"
                                                                                                title="Grant Exemption"
                                                                                                onClick={() => {
                                                                                                    handleExemption(module?.ModuleId, item?.id, module?.courseGradeDetails?.grant_exemption == 0 ? 1 : 0, module);
                                                                                                }}
                                                                                            >
                                                                                                <i className="fal font-small fa-user-times"></i>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    </>) : <>
                                                                                        {courseGradeDetails?.pass_status === "N/A" ? (
                                                                                            <div>{RenderQuizAttemptResultStatus("pending calculation").html}</div>
                                                                                        ) : (
                                                                                            <span className="empty-status">N/A</span>
                                                                                        )}
                                                                                    </>
                                                                            }
                                                                            </>
                                                                                : (<span className="text-danger">
                                                                                    Not Enrolled
                                                                                </span>)}
                                                                        </div>
                                                                    </td>
                                                                );
                                                            }) : <td></td>}
                                                        </tr>
                                                    )) : (<tr><td></td></tr>)}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={
                                        "table-book-right " +
                                        (percentageView
                                            ? moduleHeader?.length < 9
                                                ? "many-items"
                                                : "max-width-fit-content"
                                            : moduleHeader?.length < 9
                                                ? "many-items"
                                                : "max-width-fit-content")
                                    }
                                >
                                    <table
                                        className={
                                            "table-book-main text-center" +
                                            (percentageView
                                                ? moduleHeader?.length < 9
                                                    ? ""
                                                    : "border-shadow-custom-table"
                                                : moduleHeader?.length < 9
                                                    ? ""
                                                    : "border-shadow-custom-table")
                                        }
                                    >
                                        <thead>
                                            <tr>
                                                <th className="second-last-cell pr-1 pl-2">
                                                    <div className="tb-book-tit">
                                                        Programme Grade
                                                        <span
                                                            className=" grade-info-red"
                                                                data-toggle="tooltip"
                                                                title={
                                                                    tooltipValues?.passRequriedModules?.length > 0
                                                                        ? `Required pass mark on ${tooltipValues.passRequriedModules
                                                                            .map(m => m?.Portal || "-")
                                                                            .join(", ")} and a final grade above ${tooltipValues?.requiredPassMarkforProgram ?? ""}`
                                                                        : `Requires a final grade above ${tooltipValues?.requiredPassMarkforProgram ?? ""}`
                                                                }
                                                        >
                                                            <i className="fal fa-exclamation-circle pl-1"></i>
                                                        </span>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="tb-book-tit text-left">Actions</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userData?.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="pr-2 pl-2">
                                                        {item?.programCalculate?.pass_status == "N/A" ? (
                                                            <div className="as-widget-outer text-center d-flex justify-content-start gap-10">
                                                                {RenderQuizAttemptResultStatus("pending calculation").html}
                                                            </div>
                                                        ) : (item?.programCalculate?.pass_status == "N/A" && (item?.programCalculate?.scoreRecieved != "N/A" || !item?.programCalculate?.gradeText)) ? (
                                                            <div className="as-widget-outer text-center d-flex justify-content-start gap-10">
                                                                N/A
                                                            </div>
                                                        ) : (
                                                            <div className="as-widget-outer text-center d-flex justify-content-start gap-10">
                                                                {item?.programCalculate?.pass_status === "N/A"
                                                                    ? RenderQuizAttemptResultStatus("pending calculation").html
                                                                    : RenderQuizAttemptResultStatus(item?.programCalculate?.pass_status).html
                                                                }

                                                                {item.GraduationConditionMetDate != null && (
                                                                    <div><i className="fas fa-graduation-cap"></i><br /></div>
                                                                )}
                                                            </div>

                                                        )}
                                                    </td>
                                                    <td className="justify-content-end d-flex calendar-cart-item-inner">
                                                        <div className="assessment-08 btn-dropdown-grp">
                                                            <div className="as-buttons d-flex">
                                                                <PermissionsGate
                                                                    scopes={["casvview"]}
                                                                    RenderError={() => (
                                                                        <button
                                                                            disabled
                                                                            className="btn btn-primary rounded-circle"
                                                                            title="Open"
                                                                        >
                                                                            <i className="fal fa-folder-open"></i>
                                                                        </button>
                                                                    )}
                                                                >
                                                                    <Link
                                                                        className="btn btn-primary rounded-circle"
                                                                        title="Open"
                                                                        to={`/studentAdministration/students/open/${item?.id}/gradebook`}
                                                                        target="_blank"
                                                                    >
                                                                        <i className="fal fa-folder-open"></i>
                                                                    </Link>
                                                                </PermissionsGate>
                                                                <PermissionsGate
                                                                    scopes={["casvview"]}
                                                                    RenderError={() => (
                                                                        <button
                                                                            disabled
                                                                            className="btn btn-primary rounded-circle"
                                                                            title="Save Grades"
                                                                        >
                                                                            <i className="fal fa-save"></i>
                                                                        </button>
                                                                    )}
                                                                >
                                                                    <button
                                                                        className="btn btn-primary rounded-circle"
                                                                        title="Save Grades"
                                                                        disabled={item?.isDis}
                                                                        onClick={
                                                                            () =>
                                                                                handleSaveSingleGrade(item?.id)
                                                                        }
                                                                    >
                                                                        <i className="fal fa-save"></i>
                                                                    </button>
                                                                </PermissionsGate>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="custom-table-msg">{Str.noRecord}</div>
                    )}
                    <nav className="pagination-nav">
                        <div>
                            {errorMessage ? (
                                <div className="invalid-feedback d-block">{errorMessage}</div>
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="second-child">
                            <span>Rows per page:&nbsp;</span>
                            <div className="pagination-select">
                                <select
                                    defaultValue={tableState?.limit}
                                    onChange={(e) => {
                                        let value = e?.target?.value;
                                        setTableState((prevState) => ({
                                            ...prevState,
                                            limit: value ? value : 10,
                                            page: 1,
                                        }));
                                    }}
                                >
                                    {TABLE_ROWS_PER_PAGE.map((page, index) => (
                                        <option key={index}>{page}</option>
                                    ))}
                                </select>
                            </div>
                            <span className="mx-3">
                                {paginationState.from}-
                                {paginationState.to > paginationState.total
                                    ? paginationState.total
                                    : paginationState.to}{" "}
                                of {paginationState.total}
                            </span>
                            <div className="pagination-btns">
                                <button
                                    type="button"
                                    disabled={
                                        paginationState.currentPage == 1 ||
                                        paginationState.currentPage == 0
                                    }
                                    onClick={() => {
                                        if (updateValueArr?.length) {
                                            handleNavigation(null, "firstPage");
                                        } else {
                                            setTableState((prevState) => ({ ...prevState, page: 1 }));
                                        }
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                        role="presentation"
                                    >
                                        <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path>
                                        <path fill="none" d="M24 24H0V0h24v24z"></path>
                                    </svg>
                                </button>
                                <button
                                    type="button"
                                    disabled={
                                        paginationState.currentPage == 1 ||
                                        paginationState.currentPage == 0
                                    }
                                    onClick={() => {
                                        if (updateValueArr?.length) {
                                            handleNavigation(null, "prevPage");
                                        } else {
                                            setTableState((prevState) => ({
                                                ...prevState,
                                                page: paginationState.currentPage - 1,
                                            }));
                                        }
                                    }}
                                >
                                    <i className="fa-solid fa-angle-left" style={{ fontSize: 16 }}></i>
                                </button>
                                <button
                                    type="button"
                                    disabled={
                                        paginationState.currentPage == paginationState.lastPage
                                    }
                                    onClick={() => {
                                        if (updateValueArr?.length) {
                                            handleNavigation(null, "nextPage");
                                        } else {
                                            setTableState((prevState) => ({
                                                ...prevState,
                                                page: +paginationState.currentPage + 1,
                                            }));
                                        }
                                    }}
                                >
                                    <i className="fa-solid fa-angle-right" style={{ fontSize: 16 }}></i>
                                </button>
                                <button
                                    type="button"
                                    disabled={
                                        paginationState.currentPage == paginationState.lastPage
                                    }
                                    onClick={() => {
                                        if (updateValueArr?.length) {
                                            handleNavigation(null, "lastPage");
                                        } else {
                                            setTableState((prevState) => ({
                                                ...prevState,
                                                page: paginationState.lastPage,
                                            }));
                                        }
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                        role="presentation"
                                    >
                                        <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path>
                                        <path fill="none" d="M0 0h24v24H0V0z"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </>
    );
}

export default PMCGradeBook;
